module.exports = __webpack_public_path__ + "img/cooperativeCustomers.bb00f069.png";